import { render, staticRenderFns } from "./veStuIntroductionShow.vue?vue&type=template&id=1c3fbdbb&scoped=true"
import script from "./veStuIntroductionShow.vue?vue&type=script&lang=js"
export * from "./veStuIntroductionShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3fbdbb",
  null
  
)

export default component.exports